<ion-toolbar>
  <ion-buttons slot="start">
    <ion-back-button defaultHref="main" (click)="ionViewWillLeave()"></ion-back-button>
  </ion-buttons>
</ion-toolbar>

<ion-content style="background: transparent none !important;">
</ion-content>
